<img
  class="pp-coin__img"
  [src]="src()"
  [width]="size()"
  [height]="size()"
  [style.width.px]="size()"
  [style.height.px]="size()"
  alt=""
  aria-hidden="true"
  loading="lazy"
/>
